import { useCallback } from 'react';
import { scaleBand } from 'd3-scale';
import { utcDay, utcFriday, utcMonth, utcYear } from 'd3-time';

import intervals from 'maps/period-types';

export { useBandScale };

function getTimeRange(interval: any): any {
  switch (interval) {
    case intervals.day.value:
      return utcDay;
    case intervals.week.value:
      return utcFriday;
    case intervals.month.value:
      return utcMonth;
    case intervals.year.value:
      return utcYear;
    default:
      return utcFriday;
  }
}

/**
 * This helper function returns a band scale based on an interval,
 * an output range and a domain.
 *
 * @param {string} interval one of day, week, month, year
 * @param {array} range output range
 * @param {array} domain input domain
 * @returns {function}
 */
function createBandScale(interval: any, range: any, domain: any): any {
  // Get the correct time range interval generator
  const timeRange = getTimeRange(interval);

  // Create a band scale
  const scale = scaleBand()
    .range(range)
    .align(0)
    .round(true)
    // band scales need the full range of possible input values
    // as opposed to a start and an end as in most D3.js scales.
    .domain(timeRange.range(...domain));

  return scale;
}

/**
 * This hook creates a memoized callback based on a base scale's range and domain.
 *
 * @param {function} baseScale
 * @param {string} interval
 * @returns {function}
 */
function useBandScale(baseScale: any, interval: any): any {
  const scale = useCallback(
    createBandScale(interval, baseScale.range(), baseScale.domain()),
    [baseScale, interval]
  );

  return scale;
}
